import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NavUserModule } from '@common/nav-users/nav-users.module';
import { ReorderPipeModule } from '@pipes/reorder-pipe/reorder.module';
import { CommonSharedModule } from '@shared-modules/common-shared.module';
import { NgxPermissionsGuard } from 'ngx-permissions';
import { InputSwitchModule } from 'primeng/inputswitch';
import { SettingPrimeNgModule } from '../../../setting-primeNg.module';
import { StaffCommissionComponent } from '../staff-commission/staff-commission.component';
import { EditOfficeStaffComponent } from './edit-office-staff.component';
import { AssignAgentsComponent } from './assign-agents/assign-agents.component';
import { ReMultiselectModule } from '@common/re-multiselect/re-multiselect.module';
import { FeatureFlagModule } from '@directive/feature-flag/feature-flag.module';
import { ReMultipleSelectModule } from '@common/re-multi-select/re-multiselect.module';

const routes = [
  {
    path: 'staff-edit/:id',
    component: EditOfficeStaffComponent,
    canActivate: [NgxPermissionsGuard],
    data: {
      permissions: {
        only: ['staff.edit'],
        redirectTo: '/access-denied',
      },
      title: 'Staff',
      breadcrumb: [
        { label: 'Dashboard', url: '/' },
        { label: 'Contact', url: '' },
        { label: 'Office Staff', url: '/setting/office-staff' },
        { label: 'Edit Staff', url: '' },
      ],
    },
  },
];

@NgModule({
  declarations: [EditOfficeStaffComponent, StaffCommissionComponent],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    NavUserModule,
    CommonSharedModule,
    SettingPrimeNgModule,
    InputSwitchModule,
    ReorderPipeModule,
    ReMultiselectModule,
    FeatureFlagModule,
    ReMultipleSelectModule,
    AssignAgentsComponent,
  ],
  exports: [EditOfficeStaffComponent],
})
export class EditOfficeStaffModule {}
